export default "icons/lock.svg"